
import { Options, Vue } from "vue-class-component";
import { Splide, SplideSlide } from "@splidejs/vue-splide";
import "@splidejs/splide/dist/css/themes/splide-default.min.css";

@Options({
  components: { Splide, SplideSlide },
})
export default class Home extends Vue {}
